module.exports = __webpack_public_path__ + "static/fonts/Montserrat600italic.9b5089e2.ttf";